import createAxiosInstance from './Axios';
import { apiCucaIncidentBff } from '../../src/config/paths';

export const callGetRegionService = async () => {
  const axiosInstance = createAxiosInstance(apiCucaIncidentBff);
  return axiosInstance({
    url: `/region`,
    method: 'get',
  });
};
